import {Component, inject, OnInit, signal} from '@angular/core';
import {GameTablesService} from '../../services/gametables.service';
import {Router} from '@angular/router';
import {AlertService} from '../../../../shared/services/alert.service';
import {GameTable} from '../../../../shared/model/game-table';
import {ApiResponse} from '../../../../shared/model/api-response';
import {Messages} from '../../../../shared/constants/messages';
import {GameTableFormComponent} from '../game-table-form/game-table-form.component';
import {EventService} from '../../../../shared/services/event.service';
import {Event} from '../../../../shared/model/event';
import {PermissionService} from '../../../../core/services/permission.service';
import {OrgCapability, SystemPower} from '../../../../shared/model/permissions';
import {OrganizationService} from '../../../../shared/services/organization.service';
import {Organization} from '../../../../shared/model/organization';
import {NavigationHistoryService} from '../../../../core/services/navigation-history.service';

@Component({
  selector: 'app-game-table-add',
  standalone: true,
  imports: [
    GameTableFormComponent
  ],
  templateUrl: './game-table-add.component.html',
  styleUrl: './game-table-add.component.css'
})
export class GameTableAddComponent implements OnInit {
  private gameTableService: GameTablesService = inject(GameTablesService);
  private router: Router = inject(Router);
  private alertService: AlertService = inject(AlertService);
  private eventService: EventService = inject(EventService);
  private permissionService = inject(PermissionService);
  private organizationService = inject(OrganizationService);
  private navigationHistory = inject(NavigationHistoryService);

  protected availableEvents = signal<Array<Event>>([]);
  protected availableOrganizations = signal<Organization[]>([]);

  ngOnInit(): void {
    this.loadOrganizations();
    this.loadEvents();
  }

  onSubmit(tableData: Partial<GameTable>) {
    this.gameTableService.createTable(tableData).subscribe({
      next: (response: ApiResponse<GameTable>) => {
        if (response.success) {
          this.alertService.showSuccess(Messages.TABLE_CREATED_SUCCESS);
          this.router.navigate(['/tables/mine']);
        }
      },
      error: (err) => {
        if (!err?.error?.message) {
          this.alertService.showError(Messages.TABLE_SAVE_ERROR);
        }
      }
    });
  }

  onCancel() {
    this.navigationHistory.goBack(['/tables']);
  }

  private loadOrganizations(): void {
    if (this.permissionService.hasSystemPower(SystemPower.MODERATOR)) {
      this.organizationService.getAllOrganizations().subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this.availableOrganizations.set(response.data.filter((org) => org.organizationActive));
          }
        }
      });
      return;
    }
    this.availableOrganizations.set(this.permissionService.organizationsWithCapability(OrgCapability.ORG_TABLE_CREATE));
  }

  private loadEvents(): void {
    const events$ = this.permissionService.hasSystemPower(SystemPower.MODERATOR)
      ? this.eventService.getAllEvents()
      : this.eventService.getMyEvents();

    events$.subscribe({
      next: (response: ApiResponse<Array<Event>>) => {
        if (response.success && response.data) {
          this.availableEvents.set(response.data);
        }
      }
    });
  }
}
